<div class="rules-page">
  <div class="rules-header">
    <div>
      <h1>General terms</h1>
      <p>The country-neutral term catalog that country term rules are written against.</p>
    </div>
    @if (canEdit) {
      <button mat-flat-button class="btn-submit" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        New term
      </button>
    }
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (terms().length === 0) {
    <app-empty-state message="No general terms configured yet." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>Term</th>
          <th>Description</th>
          <th>Created</th>
          @if (canEdit) {
            <th></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (term of pagedTerms; track term.id) {
          <tr>
            <td><code>{{ term.term }}</code></td>
            <td>{{ term.description || '—' }}</td>
            <td>{{ term.createdAt | date: 'medium' }}</td>
            @if (canEdit) {
              <td>
                <span class="row-actions">
                  <button class="edit-btn" (click)="openEditDialog(term)" aria-label="Edit general term" title="Edit general term">
                    <svg class="edit-pen-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                      <path class="edit-pen-icon__pen" d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
                      <line class="edit-pen-icon__underline" x1="4" y1="21.5" x2="9.5" y2="21.5" />
                    </svg>
                  </button>
                  <button
                    class="remove-btn"
                    (click)="deleteTerm(term)"
                    [disabled]="deletingId() === term.id"
                    aria-label="Remove general term"
                    title="Remove general term"
                  >
                    <svg class="bin-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <g class="bin-icon__lid">
                        <line x1="4" y1="7" x2="20" y2="7" />
                        <path d="M10 7V4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V7" />
                      </g>
                      <path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" />
                      <line x1="10" y1="11" x2="10" y2="17" />
                      <line x1="14" y1="11" x2="14" y2="17" />
                    </svg>
                  </button>
                </span>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }} terms</span>
      </div>
    </div>
  }
</div>
